import Vue from "vue"

Vue.filter("localCurrency", str => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(str))
